import styles from "./Dialog.module.css";

const Backdrop = (props) => {
  return props.show ? (
    <div className={styles.Backdrop} onClick={props.switch}></div>
  ) : null;
};

export default Backdrop;
